import Map from "./Map"
const MapView: React.FC = () => {
    return (
        <div style={{ width: '100%', height: '1000px' }}>
            <Map></Map>
        </div>
    )
}

export default MapView